import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import '@/core';
import VueClipboard from 'vue-clipboard2';
import './public-path';
import Router from 'vue-router';
// import NProgress from 'nprogress';
// import 'nprogress/nprogress.css';
import asyncRoutes from '@/router/routes/async';

import { ssoLogin } from '@/utils/permission/router-permission-sso';
import basicRoutes from '@/router/routes/basic';
// import '@/mock';

Vue.config.productionTip = false;

let instance = null;
// eslint-disable-next-line
let router = null;
// import asyncRoutes from './routes/async';


// NProgress.configure({
//   showSpinner: false,
// });

Vue.use(Router);

// eslint-disable-next-line no-underscore-dangle
const routes = window.__POWERED_BY_QIANKUN__ ? basicRoutes.concat(asyncRoutes) : basicRoutes; // 不需要任何权限过滤的时候 =》 调整为 basicRoutes.concat(asyncRoutes)

console.log('__POWERED_BY_QIANKUN__', process.env.BASE_URL);

function render(props = {}) {
  const { container } = props;
  router = new Router({
    mode: 'history',
    // eslint-disable-next-line
    base: window.__POWERED_BY_QIANKUN__ ? '/linklong/manage' : 'manage',
    routes,
  });

  router.beforeEach((to, from, next) => {
    ssoLogin(router, to, from, next);
  });

  router.afterEach(() => {
    // 加载进度完成
    // NProgress.done();
    if (window.hideAppLoading) {
      window.hideAppLoading();
    }
  });

  console.log('router', router);
  instance = new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount(container ? container.querySelector('#app') : '#app');
}

Vue.use(VueClipboard);

// 独立运行时
// eslint-disable-next-line
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}


// `render`函数`new VueRouter`、`new Vue`
export async function bootstrap() {
  console.log('[vue] vue app bootstraped');
}
export async function mount(props) {
  console.log('router', router);
  console.log('[vue] props from main framework', props);
  window.handleAddModalOpen = props.globalState.handleAddModalOpen;
  window.addAppFinish = props.globalState.setQiankunAddAppFinish;
  window.hideAppLoading = () => {
    props.setLoading(false);
  };
  // eslint-disable-next-line
  render(props);
}

// eslint-disable-next-line
export async function unmount(props) {
  console.log('[vue] props unmount', props);
  instance.$destroy();
  instance.$el.innerHTML = '';
  instance = null;
  router = null;
}
